/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkoutRating } from './WorkoutRating';
import {
    WorkoutRatingFromJSON,
    WorkoutRatingFromJSONTyped,
    WorkoutRatingToJSON,
    WorkoutRatingToJSONTyped,
} from './WorkoutRating';
import type { CompletedTraining } from './CompletedTraining';
import {
    CompletedTrainingFromJSON,
    CompletedTrainingFromJSONTyped,
    CompletedTrainingToJSON,
    CompletedTrainingToJSONTyped,
} from './CompletedTraining';

/**
 * 
 * @export
 * @interface TrainingHistoryEntry
 */
export interface TrainingHistoryEntry {
    /**
     * 
     * @type {string}
     * @memberof TrainingHistoryEntry
     */
    entryId: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingHistoryEntry
     */
    planWorkoutId?: string;
    /**
     * 
     * @type {WorkoutRating}
     * @memberof TrainingHistoryEntry
     */
    rating?: WorkoutRating;
    /**
     * 
     * @type {string}
     * @memberof TrainingHistoryEntry
     */
    deckId: string;
    /**
     * 
     * @type {number}
     * @memberof TrainingHistoryEntry
     */
    completionTime: number;
    /**
     * 
     * @type {number}
     * @memberof TrainingHistoryEntry
     */
    bodyweight: number;
    /**
     * 
     * @type {string}
     * @memberof TrainingHistoryEntry
     */
    trainingDateIsoString: string;
    /**
     * 
     * @type {CompletedTraining}
     * @memberof TrainingHistoryEntry
     */
    completedTraining: CompletedTraining;
}

/**
 * Check if a given object implements the TrainingHistoryEntry interface.
 */
export function instanceOfTrainingHistoryEntry(value: object): value is TrainingHistoryEntry {
    if (!('entryId' in value) || value['entryId'] === undefined) return false;
    if (!('deckId' in value) || value['deckId'] === undefined) return false;
    if (!('completionTime' in value) || value['completionTime'] === undefined) return false;
    if (!('bodyweight' in value) || value['bodyweight'] === undefined) return false;
    if (!('trainingDateIsoString' in value) || value['trainingDateIsoString'] === undefined) return false;
    if (!('completedTraining' in value) || value['completedTraining'] === undefined) return false;
    return true;
}

export function TrainingHistoryEntryFromJSON(json: any): TrainingHistoryEntry {
    return TrainingHistoryEntryFromJSONTyped(json, false);
}

export function TrainingHistoryEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainingHistoryEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'entryId': json['entryId'],
        'planWorkoutId': json['planWorkoutId'] == null ? undefined : json['planWorkoutId'],
        'rating': json['rating'] == null ? undefined : WorkoutRatingFromJSON(json['rating']),
        'deckId': json['deckId'],
        'completionTime': json['completionTime'],
        'bodyweight': json['bodyweight'],
        'trainingDateIsoString': json['trainingDateIsoString'],
        'completedTraining': CompletedTrainingFromJSON(json['completedTraining']),
    };
}

export function TrainingHistoryEntryToJSON(json: any): TrainingHistoryEntry {
    return TrainingHistoryEntryToJSONTyped(json, false);
}

export function TrainingHistoryEntryToJSONTyped(value?: TrainingHistoryEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entryId': value['entryId'],
        'planWorkoutId': value['planWorkoutId'],
        'rating': WorkoutRatingToJSON(value['rating']),
        'deckId': value['deckId'],
        'completionTime': value['completionTime'],
        'bodyweight': value['bodyweight'],
        'trainingDateIsoString': value['trainingDateIsoString'],
        'completedTraining': CompletedTrainingToJSON(value['completedTraining']),
    };
}

